module.exports = __webpack_public_path__ + "img/station-icon_2.6fe3e767.png";